export default "__VITE_ASSET__zyoROj7d__"